import { render, staticRenderFns } from "./rewards.vue?vue&type=template&id=52e8b708&"
import script from "./rewards.vue?vue&type=script&lang=js&"
export * from "./rewards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports